export default __webpack_public_path__ + "static/media/work-space.aef49011.jpeg";